import { render } from "./CityCreateComponent.vue?vue&type=template&id=dfca4de2"
import script from "./CityCreateComponent.vue?vue&type=script&lang=js"
export * from "./CityCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__